import { FunnelChartElement } from 'mojo-funnel-chart/lib/models';

export interface ReferralCountByStage {
  name: string;
  count: number;
  total: number;
}

const STAGE_COLOR_CODES = ['#B3DAFC', '#80C2FA', '#4DA9F7', '#2696F6', '#007CF3', '#0067EF'];

const EMPTY_COLOR = '#cacaca';

export class ReferralCountByStageAdapter {
  constructor(private countsByStage: ReferralCountByStage[] = []) {}

  private getUnUsedColor(index: number): string {
    return STAGE_COLOR_CODES.length > index
      ? STAGE_COLOR_CODES[index]
      : STAGE_COLOR_CODES[Math.floor(Math.random() * STAGE_COLOR_CODES.length)];
  }

  get elements(): FunnelChartElement[] {
    return this.countsByStage.map((countByStage, index) => ({
      ...countByStage,
      color: countByStage.total > 0 ? this.getUnUsedColor(index) : EMPTY_COLOR,
    }));
  }

  get total(): number {
    return this.countsByStage.length > 0 ? this.countsByStage[0].total : 0;
  }
}
